export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

export const TOOL_MESSAGING_MAP: Record<string, string> = {
    "get_patient_drug_regimens": "\n\n > Getting customer's drug regimens..."
} as const;

// Suggested response feedback context identifiers
export const SUGGESTED_RESPONSE_CONTEXT = {
    CONVERSE: 'converse_suggested_response',
    RECOMMENDATION: 'recommendation_suggested_response',
    SUMMARY: 'summary_suggested_response',
    DEFAULT: 'suggested_response'
} as const;

// Frontend metrics event types
export const METRICS_EVENTS = {
    COPY_RECOMMENDATION_SUGGESTED_RESPONSE: 'copy_recommendation_suggested_response',
    COPY_CONVERSE_SUGGESTED_RESPONSE: 'copy_converse_suggested_response',
    COPY_SUMMARY_SUGGESTED_RESPONSE: 'copy_summary_suggested_response',
    VIEW_RECOMMENDATION_DETAILS: 'view_recommendation_details',
    VIEW_SUMMARY_DETAILS: 'view_summary_details',
    // Emitted when the shoulder-tap poll-loop watchdog detects a stall and
    // force-restarts polling. Lets us evaluate, down the road, whether the
    // watchdog is actually firing in the field (and how often) or is dead code.
    SHOULDER_TAP_WATCHDOG_RESTART: 'shoulder_tap_watchdog_restart',
    // Periodic proof-of-life from the shoulder-tap poll loop, carrying the
    // poll sequence number, tab visibility, and how late the timer fired.
    // The *absence* of these is the signal: if heartbeats stop while the host
    // frame is still alive, the frame died rather than merely being throttled.
    SHOULDER_TAP_HEARTBEAT: 'shoulder_tap_heartbeat',
    // The poll loop's effect cleanup ran. Distinguishes an intentional
    // teardown (contact change, unmount, auth flip) from the frame dying.
    SHOULDER_TAP_POLL_TEARDOWN: 'shoulder_tap_poll_teardown',
    // An uncaught render error was contained by the error boundary. Before
    // the boundary existed this unmounted the whole tree, which silently
    // killed polling.
    UI_RENDER_ERROR: 'ui_render_error',
    // An uncaught error or promise rejection reached the window. These bypass
    // React error boundaries entirely.
    UI_UNCAUGHT_ERROR: 'ui_uncaught_error',
    // An API call was answered by the ALB's auth redirect (or a 401/403),
    // meaning the session died while the app was in use. The ALB session
    // cookie has a fixed lifetime measured from sign-in rather than a sliding
    // one, so this fires mid-contact for any agent who signed in ~24h earlier.
    // Emitted once per auth-loss episode, not once per failed request.
    AUTH_SESSION_LOST: 'auth_session_lost',
    // A re-authentication after AUTH_SESSION_LOST succeeded. The ratio of this
    // to AUTH_SESSION_LOST is the health signal: they should track 1:1. A
    // shortfall means recovery is failing in the field (popup blocked, cookie
    // not reaching the partitioned frame) and agents are being left stranded.
    AUTH_SESSION_RECOVERED: 'auth_session_recovered',
    // The shoulder-tap service went from healthy (or unknown) to offline —
    // the config fetch failed or polls stopped succeeding. Service health is
    // no longer published to the host over the bridge, so these two events
    // are the only visibility into degradation in the field.
    SERVICE_HEALTH_OFFLINE: 'service_health_offline',
    // Recovery after SERVICE_HEALTH_OFFLINE. As with the auth pair, the ratio
    // is the signal: offline flips without a matching recovery mean agents sat
    // in a degraded state for the rest of the contact.
    SERVICE_HEALTH_RECOVERED: 'service_health_recovered'
} as const;

// WebSocket message types
export const WEBSOCKET_MESSAGE_TYPES = {
    FRONTEND_METRIC: 'frontend_metric'
} as const;
